<template>
  <v-form ref="form" lazy-validation @submit.prevent>
    <FormSection>
      <BaseHeading level="3">{{ $t('complaintForm.worktimeFormCompensationHeader') }}</BaseHeading>

      <BaseCheckbox
        v-model="acceptRegreasing"
        :error-messages="acceptRegreasingErrors"
        required
        @input="touch('acceptRegreasing')"
        @blur="touch('acceptRegreasing')"
      >
        <BaseRichtext :html="$t('complaintForm.regreaseMotor')" />
      </BaseCheckbox>

      <ComplaintFormStepperControls
        :is-valid="isValid"
        :has-required-fields="true"
        :prev-step="prevStep"
        :next-step="submit"
      />
    </FormSection>
  </v-form>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

import StepperMixin from '@/js/mixins/stepper-mixin.js'
import FormValidationMixin from '@/js/components/Forms/mixins/form-validation-mixin.js'
import ComplaintFormMixin from '@/js/components/Forms/ComplaintForm/_mixins/complaint-form-default-mixin.js'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_MUTATION from '@/js/components/Forms/ComplaintForm/_store-module/mutation-types.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

import FormSection from '@/js/components/Forms/FormSection.vue'

import ComplaintFormStepperControls from '../../ComplaintFormStepperControls.vue'

export default {
  name: 'ComplaintFormWorktimeCompensation',
  components: {
    FormSection,
    ComplaintFormStepperControls,
  },
  mixins: [FormValidationMixin, ComplaintFormMixin],
  props: {
    ...StepperMixin.props,
  },
  data() {
    return {
      acceptRegreasing: false,
    }
  },
  validations: {
    acceptRegreasing: {
      checked(val) {
        return val
      },
    },
  },
  computed: {
    /** Getters */
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      steps: FORM_GETTER.STEPS,
    }),
    formData() {
      return {
        acceptRegreasing: this.acceptRegreasing,
        description: ' ',
        errorFrequency: ' ',
      }
    },

    /** Errors */
    acceptRegreasingErrors() {
      return this.formErrorHelper('acceptRegreasing', [
        {
          condition: 'checked',
          error: this.chooseErrorMessage,
        },
      ])
    },
  },
  methods: {
    ...mapMutations(FORM_CONSTANTS.STORE_ID, {
      updateFormData: FORM_MUTATION.UPDATE_FORM_DATA,
    }),
    submitCallback() {
      this.updateFormData(this.formData)
      this.nextStep()
    },
  },
}
</script>
